import React from 'react';
import styled from 'styled-components';

import { BREAKPOINTS, SCAFFOLDING } from 'theme';

const UnavailableWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 10;
    padding: ${SCAFFOLDING.GUTTER};
    background-color: #f6f7f6;
    color: #999;
    font-style: italic;
    text-align: center;

    @media (min-width: ${`${BREAKPOINTS.md}px`}) {
        display: none;
    }
`;

export default function Unavailable(props) {
    return (
        <UnavailableWrapper {...props}>
            <div>The editor is currently unavailable at this size.</div>
        </UnavailableWrapper>
    );
}
